import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "article-details-page" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "article-details-content" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.getCdnImageAddress(_ctx.articleData.articleImage, `w_1028,h_290/`)})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.articleData)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.articleData.title), 1))
            : _createCommentVNode("", true)
        ])
      ], 4),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", {
              innerHTML: _ctx.articleData.description
            }, null, 8, _hoisted_8)
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter)
  ]))
}